import { useMemo } from 'react';

import PDFViewer from '@/components/organisms/PDFViewer';
import { BoundingBox } from '@/types';

const ChunkDocViewer = ({
  caseId,
  docId,
  chunkId,
  boundingBoxes,
  onClose,
}: {
  caseId: string | null;
  docId: string;
  chunkId: string;
  boundingBoxes: BoundingBox[];
  onClose: () => void;
}) => {
  const coordinates = useMemo(() => {
    return boundingBoxes.map((boundingBox) => ({
      ...boundingBox,
      id: chunkId,
    }));
  }, [boundingBoxes, chunkId]);

  if (!caseId) {
    return null;
  }

  return (
    <div className="flex h-full flex-col">
      <div className="flex-grow overflow-hidden">
        <div className="relative h-full">
          <PDFViewer
            caseId={caseId}
            docId={docId}
            highlights={coordinates}
            closeViewer={onClose}
            highlightedFactId={chunkId}
          />
        </div>
      </div>
    </div>
  );
};

export default ChunkDocViewer;
